import {Component, Input} from '@angular/core';
import {Events, NavParams, ViewController} from 'ionic-angular';
import {HttpClient} from "@angular/common/http";
import {ApiErrorHandlerProvider} from "../../providers/api-error-handler/api-error-handler";
import {BookingServiceProvider} from "../../providers/booking-service/booking-service";

/**
 * Generated class for the CancelModalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-cancel-modal',
    templateUrl: 'cancel-modal.html',
})
export class CancelModalPage {

    booking: any;
    loading: boolean;
    errors: {};

    constructor(
      public viewCtrl: ViewController,
      public navParams: NavParams,
      public events: Events,
      private http: HttpClient,
      private apiErrorHandler: ApiErrorHandlerProvider
    ) {
        this.booking = navParams.get('booking');
    }

    cancelBooking() {
        this.loading = true;

        this.http.post(`/bookings/${this.booking.id}/cancel`, {}).subscribe((booking) => {
            this.errors = {};
            this.loading = false;
            this.viewCtrl.dismiss(booking);
        }, error => {
            this.loading = false;
            this.errors = this.apiErrorHandler.handleError(error);
        }, () => {

        });
    }

    getTotalCost(booking) {

        if (booking.total_paid > 0) return booking.total_paid;

        let total = 0;
        if (booking && booking.services && booking.services.length) {
            booking.services.forEach(function (service) {
                total += service.quantity * service.price;
            });
        }
        return total;
    }

    closeModal() {
        this.viewCtrl.dismiss();
    }

}



// WEBPACK FOOTER //
// ./src/pages/cancel-modal/cancel-modal.ts